import { AiFillEye } from "react-icons/ai";
import { FaGlobe, FaDollarSign } from "react-icons/fa"; // ═══ ADDED FaDollarSign ═══
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import { isEmpty, startCase } from "lodash";
import { BsArrowUpShort } from "react-icons/bs";
import TableHeaderCell from "components/reusable/TableHeaderCell";

const FinalEmployeeTable = ({ sort, page, setSort, employeeList, handleView, handleGeoIp, handleWageSetup }) => { // ═══ ADDED handleWageSetup ═══
  const { t } = useTranslation();
  return (
    <div>
      <div className="p-3">
        <div className="relative overflow-x-auto rounded-lg border">
          <table className="text-left text-[#6c6c6c] w-full text-xs dark:text-gray-400 ">
            <thead className="dark:bg-gray-700 dark:text-gray-400 text-xs text-gray-900 border border-[#E1E6EE] bg-[#E1E6EE]">
              <tr>
                <TableHeaderCell text={t("SR_NO")} />
                <TableHeaderCell text={t("EMPLOYEE_ID")} />
                <TableHeaderCell text={t("EMPLOYEE_NAME")} />
                <TableHeaderCell text={t("JOB_TITLE")} />
                <TableHeaderCell text={t("DEPARTMENT")} />
                <TableHeaderCell text={t("YEAR_OF_EXPERIENCE")} />

                <th
                  scope="col"
                  className="px-6 cursor-pointer py-3 "
                  onClick={() => {
                    const newSortType = sort.sortType === "asc" ? "desc" : "asc";
                    setSort({
                      sortBy: "acceptedRejectedAt",
                      sortType: newSortType,
                    });
                  }}
                >
                  <div className="flex justify-start">
                    <span>{t("ACCEPT_REJECT_DATE")}</span>
                    <span>{sort.sortBy === "acceptedRejectedAt" && <BsArrowUpShort className={`w-4 h-4 ${sort.sortType === "asc" ? "" : "rotate-180"}`} />}</span>
                  </div>
                </th>
                <th
                  scope="col"
                  className="px-6 cursor-pointer py-3 "
                  onClick={() => {
                    const newSortType = sort.sortType === "asc" ? "desc" : "asc";
                    setSort({
                      sortBy: "Employee.email",
                      sortType: newSortType,
                    });
                  }}
                >
                  <div className="flex justify-start">
                    <span>{t("EMAIL_ID")}</span>
                    <span>{sort.sortBy === "Employee.email" && <BsArrowUpShort className={`w-4 h-4 ${sort.sortType === "asc" ? "" : "rotate-180"}`} />}</span>
                  </div>
                </th>

                <th scope="col" className="text-center py-3 px-6">
                  {t("FORM_STATUS")}
                </th>
                <th className="py-3 px-6 text-center" scope="col">
                  {t("O_ACTION")}
                </th>
              </tr>
            </thead>
            <tbody>
              {employeeList &&
                employeeList.map((item, i) => {
                  // ═══ ADDED: Determine if employee is terminated ═══
                  const isTerminated = item?.employmentStatus === "terminated";

                  return (
                    <tr key={i} className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                      <th scope="row" className="py-4 px-6 border-r font-medium text-gray-900  dark:text-white">
                        {i + 1 + 10 * (page - 1)}
                      </th>
                      <td className="border-r py-4 px-4 text-gray-900">
                        {isTerminated
                          ? `${item?.Company?.name?.substring(0, 3) || ""}${item?.Employee?._id?.toString().slice(-3) || ""}`
                          : item?.Employee?.employeeId}
                      </td>
                      <td className="py-4 text-gray-900 px-6 border-r ">{item?.Employee?.name}</td>
                      <td className="px-6 border-r py-4 text-gray-900">{item?.Job?.name}</td>
                      <td className="py-4 border-r px-6 text-gray-900">{item?.Department?.name}</td>
                      <td className="py-4 px-6 border-r text-gray-900">{item?.yearOfExperiece}</td>

                      <td className="px-6 border-r py-4  text-left text-gray-900">{item?.acceptedRejectedAt ? dayjs(item?.acceptedRejectedAt).format("MM-DD-YYYY h:mm A") : "N/A"} </td>
                      <td className="py-4 px-6 text-gray-900  border-r">{item?.Employee?.email}</td>
                      <td className="py-4 px-6 border-r text-gray-900">{startCase(item?.formStatus)}</td>

                      <td className="py-4 px-6 border-l text-gray-900">
                        <div className="">
                          <ul className="flex justify-center items-center gap-2">
                            {/* ═══ ADDED: Set Wage Icon ═══ */}
                            {!isTerminated && (
                              <li
                                onClick={() => handleWageSetup && handleWageSetup(item)}
                                className="hover:bg-white px-2 py-2 hover:text-green-600"
                              >
                                <a title="Set Wage">
                                  <FaDollarSign className="cursor-pointer text-slate-600 w-5 h-5" />
                                </a>
                              </li>
                            )}

                            {/* COMMENTED: GeoIP — uncomment if needed for accountant
                            <li
                              onClick={() => handleGeoIp && handleGeoIp(item)}
                              className="hover:bg-white px-2 py-2 hover:text-LightBlue"
                            >
                              <a title="Add or block employee IP">
                                <FaGlobe className="cursor-pointer text-slate-600 w-5 h-5" />
                              </a>
                            </li>
                            */}

                            <li onClick={() => handleView(item)} className="hover:bg-white px-2 py-2 hover:text-LightBlue">
                              <a title="View employee list">
                                {" "}
                                <AiFillEye className="cursor-pointer text-slate-600 w-5 h-5 " />{" "}
                              </a>
                            </li>
                          </ul>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              {isEmpty(employeeList) ? (
                <tr className="bg-white text-center dark:bg-gray-800 border-b  dark:border-gray-700">
                  <td colSpan={10} className="py-4 px-6 border-r">
                    {t("O_NO_RECORD_FOUND")}
                  </td>
                </tr>
              ) : null}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default FinalEmployeeTable;





// import { AiFillEye } from "react-icons/ai";
// import { FaGlobe } from "react-icons/fa";
// import { useTranslation } from "react-i18next";
// import dayjs from "dayjs";
// import { isEmpty, startCase } from "lodash";
// import { BsArrowUpShort } from "react-icons/bs";
// import TableHeaderCell from "components/reusable/TableHeaderCell";

// const FinalEmployeeTable = ({ sort, page, setSort, employeeList, handleView, handleGeoIp }) => {
//   const { t } = useTranslation();
//   return (
//     <div>
//       <div className="p-3">
//         <div className="relative overflow-x-auto rounded-lg border">
//           <table className="text-left text-[#6c6c6c] w-full text-xs dark:text-gray-400 ">
//             <thead className="dark:bg-gray-700 dark:text-gray-400 text-xs text-gray-900 border border-[#E1E6EE] bg-[#E1E6EE]">
//               <tr>
//                 <TableHeaderCell text={t("SR_NO")} />
//                 <TableHeaderCell text={t("EMPLOYEE_ID")} />
//                 <TableHeaderCell text={t("EMPLOYEE_NAME")} />
//                 <TableHeaderCell text={t("JOB_TITLE")} />
//                 <TableHeaderCell text={t("DEPARTMENT")} />
//                 <TableHeaderCell text={t("YEAR_OF_EXPERIENCE")} />

//                 <th
//                   scope="col"
//                   className="px-6 cursor-pointer py-3 "
//                   onClick={() => {
//                     const newSortType = sort.sortType === "asc" ? "desc" : "asc";
//                     setSort({
//                       sortBy: "acceptedRejectedAt",
//                       sortType: newSortType,
//                     });
//                   }}
//                 >
//                   <div className="flex justify-start">
//                     <span>{t("ACCEPT_REJECT_DATE")}</span>
//                     <span>{sort.sortBy === "acceptedRejectedAt" && <BsArrowUpShort className={`w-4 h-4 ${sort.sortType === "asc" ? "" : "rotate-180"}`} />}</span>
//                   </div>
//                 </th>
//                 <th
//                   scope="col"
//                   className="px-6 cursor-pointer py-3 "
//                   onClick={() => {
//                     const newSortType = sort.sortType === "asc" ? "desc" : "asc";
//                     setSort({
//                       sortBy: "Employee.email",
//                       sortType: newSortType,
//                     });
//                   }}
//                 >
//                   <div className="flex justify-start">
//                     <span>{t("EMAIL_ID")}</span>
//                     <span>{sort.sortBy === "Employee.email" && <BsArrowUpShort className={`w-4 h-4 ${sort.sortType === "asc" ? "" : "rotate-180"}`} />}</span>
//                   </div>
//                 </th>

//                 <th scope="col" className="text-center py-3 px-6">
//                   {t("FORM_STATUS")}
//                 </th>
//                 <th className="py-3 px-6 text-center" scope="col">
//                   {t("O_ACTION")}
//                 </th>
//               </tr>
//             </thead>
//             <tbody>
//               {employeeList &&
//                 employeeList.map((item, i) => {
//                   return (
//                     <tr key={i} className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
//                       <th scope="row" className="py-4 px-6 border-r font-medium text-gray-900  dark:text-white">
//                         {i + 1 + 10 * (page - 1)}
//                       </th>
//                       <td className="border-r py-4 px-4 text-gray-900">
//                         {item?.employmentStatus === "terminated"
//                           ? `${item?.Company?.name?.substring(0, 3) || ""}${item?.Employee?._id?.toString().slice(-3) || ""}`
//                           : item?.Employee?.employeeId}
//                       </td>
//                       {/* <td className="py-4 px-6 border-r text-gray-900">{item?.Employee?.employeeId}</td> */}
//                       <td className="py-4 text-gray-900 px-6 border-r ">{item?.Employee?.name}</td>
//                       <td className="px-6 border-r py-4 text-gray-900">{item?.Job?.name}</td>
//                       <td className="py-4 border-r px-6 text-gray-900">{item?.Department?.name}</td>
//                       <td className="py-4 px-6 border-r text-gray-900">{item?.yearOfExperiece}</td>

//                       <td className="px-6 border-r py-4  text-left text-gray-900">{item?.acceptedRejectedAt ? dayjs(item?.acceptedRejectedAt).format("MM-DD-YYYY h:mm A") : "N/A"} </td>
//                       <td className="py-4 px-6 text-gray-900  border-r">{item?.Employee?.email}</td>
//                       <td className="py-4 px-6 border-r text-gray-900">{startCase(item?.formStatus)}</td>

//                       <td className="py-4 px-6 border-l text-gray-900">
//                         <div className="">
//                           <ul className="flex justify-center">
//                             {/* <li
//                               onClick={() => handleGeoIp && handleGeoIp(item)}
//                               className="hover:bg-white px-2 py-2 hover:text-LightBlue"
//                             >
//                               <a title="Add or block employee IP">
//                                 <FaGlobe className="cursor-pointer text-slate-600 w-5 h-5" />
//                               </a>
//                             </li> */}
//                             <li onClick={() => handleView(item)} className="hover:bg-white px-2 py-2 hover:text-LightBlue">
//                               <a title="View employee list">
//                                 {" "}
//                                 <AiFillEye className="cursor-pointer text-slate-600 w-5 h-5 " />{" "}
//                               </a>
//                             </li>
//                           </ul>
//                         </div>
//                       </td>
//                     </tr>
//                   );
//                 })}
//               {isEmpty(employeeList) ? (
//                 <tr className="bg-white text-center dark:bg-gray-800 border-b  dark:border-gray-700">
//                   <td colSpan={10} className="py-4 px-6 border-r">
//                     {t("O_NO_RECORD_FOUND")}
//                   </td>
//                 </tr>
//               ) : null}
//             </tbody>
//           </table>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default FinalEmployeeTable;
